/** PM Message Actions — action menus, reply, mobile interactions, swipe-to-reply. */

function isMessageActionMenuOpen() {
  return $(".msg-actions-menu:not(.hidden)").length > 0;
}

// The dropdown is positioned once against its trigger's viewport rect, so a
// scroll (capture phase, to catch the inner message list) or a resize detaches
// it. Dismiss rather than re-anchor, matching the reaction popover.
function onMessageActionsViewportChange() {
  window.closeMessageActionMenus();
}

/**
 * Close every open message actions dropdown and unpin the owning toolbar. Every
 * caller that hides a dropdown must go through here, otherwise `.msg-actions-open`
 * leaks and the toolbar stays pinned visible with no menu attached.
 */
window.closeMessageActionMenus = function() {
  // Everything here is a no-op when its selector misses, so the un-pin runs
  // unconditionally. A `.msg-actions-open` stranded on a live node would hold the
  // `:has()` suppression forever, and nothing else can clear it.
  document.removeEventListener('scroll', onMessageActionsViewportChange, true);
  window.removeEventListener('resize', onMessageActionsViewportChange);

  $(".msg-actions-menu:not(.hidden)").addClass("hidden");
  $(".msg-actions-toggle[aria-expanded='true']").attr("aria-expanded", "false");

  const $pinned = $(".pm-msg-toolbar.msg-actions-open");
  if (!$pinned.length) {
    return;
  }

  // Drop the offsets clampHoveredToolbar() held for the open menu (see
  // clearToolbarPin in pm/reactions.js), then let it re-derive them: on a bubble
  // taller than the viewport the CSS placement can sit off screen.
  $pinned.removeClass("msg-actions-open").css({ top: "", bottom: "" });
  if (window.clampHoveredMessageToolbar) {
    window.clampHoveredMessageToolbar();
  }
};

// Vertical band the dropdown may occupy. The conversation header overlays the top
// of the message list, and the compose area sits directly below it.
function messageActionsBounds() {
  var top = 4;
  var bottom = window.innerHeight - 4;

  var header = document.getElementById('conversation-header');
  if (header && !header.classList.contains('hidden')) {
    top = header.getBoundingClientRect().bottom + 4;
  }

  var compose = document.getElementById('threads_right_bottom');
  if (compose && !compose.classList.contains('hidden')) {
    bottom = compose.getBoundingClientRect().top - 4;
  }

  return { top: top, bottom: bottom };
}

window.toggleMessageActions = function(event, msgId) {
  event.preventDefault();
  event.stopPropagation();

  // On mobile, use the bottom sheet instead of inline dropdown
  if (window.matchMedia('(max-width: 639px)').matches && window.openMessageActionsSheet) {
    window.openMessageActionsSheet(msgId);
    return;
  }

  const $menu = $("#msg-actions-" + msgId);
  const wasOpen = !$menu.hasClass("hidden");

  // Close every menu (including this one) and clear the pinned-toolbar state.
  window.closeMessageActionMenus();
  if (wasOpen) {
    return;
  }

  $menu.removeClass("hidden");

  // Pin the owning toolbar: it stays visible regardless of :hover, and it paints
  // above the compose bar and every other message's toolbar, so the menu is the
  // topmost hit target over its own footprint.
  const button = $(event.currentTarget);
  button.closest(".pm-msg-toolbar").addClass("msg-actions-open");
  button.attr("aria-expanded", "true");

  document.addEventListener('scroll', onMessageActionsViewportChange, true);
  window.addEventListener('resize', onMessageActionsViewportChange);

  // Position the menu using fixed coordinates so it escapes the scroll container
  const buttonRect = button[0].getBoundingClientRect();

  // Fixed positioning escapes the scroll container's clip. It does not escape the
  // toolbar's stacking context, which is why the toolbar carries the z-index.
  $menu.css({ position: "fixed", top: "", bottom: "", left: "", right: "" });

  var menuRight = window.innerWidth - buttonRect.right;

  // offsetWidth/offsetHeight report the untransformed layout box, so no transform
  // the fadeIn keyframe grows can ever skew the placement arithmetic.
  const menuWidth = $menu[0].offsetWidth;
  const menuHeight = $menu[0].offsetHeight;
  const bounds = messageActionsBounds();

  const below = buttonRect.bottom + 4;
  const above = buttonRect.top - menuHeight - 4;
  const viewportTop = 4;
  const viewportBottom = window.innerHeight - 4;

  // Sit below the trigger, flipping above it when the compose area is in the way
  // and there is room under the header. Overhanging either is fine: the pinned
  // toolbar's z-index paints the menu over both. Clamping into the band is not,
  // because it parks the menu over its own trigger and a second click on the
  // toggle lands on a menu item.
  var menuTop = below;
  if (below + menuHeight > bounds.bottom && above >= bounds.top) {
    menuTop = above;
  }

  // The band is a preference, the viewport is not: an item past the fold cannot
  // be reached. Flip above the trigger to recover, and only when the menu fits
  // neither way pull it back on screen over its own trigger.
  if (menuTop + menuHeight > viewportBottom) {
    menuTop = above >= viewportTop
      ? above
      : Math.max(viewportTop, viewportBottom - menuHeight);
  }

  // Keep within left edge
  if (buttonRect.right - menuWidth < 0) {
    menuRight = window.innerWidth - buttonRect.left - menuWidth;
  }

  $menu.css({ top: menuTop + "px", right: menuRight + "px" });
};

// Escape dismisses the desktop dropdown. When focus sits on a menu item, hiding
// the menu would drop it to <body>, so hand it back to the trigger.
$(document).on('keydown', function(e) {
  if (e.key !== 'Escape' || !isMessageActionMenuOpen()) {
    return;
  }
  const $trigger = $(document.activeElement)
    .closest('.msg-actions-wrapper')
    .find('.msg-actions-toggle');
  window.closeMessageActionMenus();
  $trigger.trigger('focus');
});

// Focus leaving the dropdown dismisses it, the keyboard counterpart of a click
// outside. Without it, tabbing past the last item strands an open menu that keeps
// every other toolbar in the thread suppressed.
$(document).on('focusout', '.msg-actions-wrapper', function(e) {
  if (!e.relatedTarget || !this.contains(e.relatedTarget)) {
    window.closeMessageActionMenus();
  }
});

// The first click on the message list, outside an open dropdown, only dismisses
// it. Capture phase, so the click never reaches the delegated handlers beneath the
// menu: dismissing over a photo would otherwise also open the lightbox, and over a
// link would navigate. Only `#threads_right` is covered, because only it sits
// under the menu. The compose bar, the thread list and the site nav keep their
// first click.
//
// Exempt are the open message's toolbar controls, which stay painted and
// interactive, and clicks with no pointer behind them (`detail === 0`, e.g. a
// keyboard activation or `element.click()`), which never land on the menu.
document.addEventListener('click', function(e) {
  if (!isMessageActionMenuOpen() || !e.target.closest) {
    return;
  }
  if (e.target.closest('.pm-msg-toolbar.msg-actions-open button, .msg-actions-menu')) {
    return;
  }
  if (e.detail !== 0 && e.target.closest('#threads_right')) {
    e.preventDefault();
    e.stopPropagation();
  }
  window.closeMessageActionMenus();
}, true);

/**
 * Reply to a message - activates reply mode in the compose box
 */
window.replyToMessage = function(msgId) {
  window.closeMessageActionMenus();

  var $msg = $("#msg_" + msgId);
  var senderName = $msg.data("sender-name") || "";
  var msgPreview = $msg.data("msg-preview") || "";

  $("#reply_preview_sender").text(senderName);
  $("#reply_preview_text").text(msgPreview);
  $("#reply_to_id").val(String(msgId));
  $("#reply_preview_container").removeClass("hidden");

  $("#message").focus();
};

/**
 * Cancel reply mode - clears the reply preview
 */
window.cancelReply = function() {
  $("#reply_preview_container").addClass("hidden");
  $("#reply_preview_sender").text("");
  $("#reply_preview_text").text("");
  $("#reply_to_id").val("");
};

// ---------------------------------------------------------------------------
// Mobile: Tap on message → reveal reply + more buttons inline
// Desktop: CSS group-hover handles it (sm:opacity-0 → sm:group-hover:opacity-100)
// ---------------------------------------------------------------------------
(function() {
  var activeMsgId = null;
  var activeSheetMsgId = null;
  var sheetCloseTimer = null;

  // Long-press state. A photo opens the lightbox on tap, so long-press is the
  // way to reach its react/reply/more toolbar on touch devices.
  var LONG_PRESS_MS = 500;
  var longPressTimer = null;
  // After a long-press fires we must swallow exactly one click: the synthetic
  // click the browser emits for the same photo on release. Scope the suppression
  // to that photo element so it can never swallow a tap on anything else (a
  // concurrent second finger, a later click elsewhere on the page). A timer
  // disarms it after the window in case no release click is emitted (iOS,
  // touchcancel, a context menu), so a detached node is never retained.
  var SUPPRESS_CLICK_MS = 1000;
  var suppressClickEl = null;
  var suppressClickTimer = null;

  function isMobile() {
    return window.matchMedia('(max-width: 639px)').matches;
  }

  function clearLongPress() {
    if (longPressTimer) {
      clearTimeout(longPressTimer);
      longPressTimer = null;
    }
  }

  function disarmSuppressClick() {
    suppressClickEl = null;
    if (suppressClickTimer) {
      clearTimeout(suppressClickTimer);
      suppressClickTimer = null;
    }
  }

  function getMsgId(el) {
    var $msg = $(el).closest('.pm_msg');
    if (!$msg.length) return null;
    var id = $msg.attr('id');
    return id ? id.replace('msg_', '') : null;
  }

  function getMsgData(msgId) {
    var $msg = $('#msg_' + msgId);
    if (!$msg.length) return null;
    var currentUserId = $('meta[name="user-id"]').attr('content') || '';
    var senderId = String($msg.data('sender-id') || '');
    return {
      id: msgId,
      senderName: $msg.data('sender-name') || '',
      preview: $msg.data('msg-preview') || '',
      isOwnMessage: senderId === currentUserId || $msg.data('optimistic') === true,
      // data-edit-source is present only on rows the server marked editable.
      canEdit: $msg[0].hasAttribute('data-edit-source')
    };
  }

  // Show inline action buttons on a specific message (mobile tap-to-reveal)
  function showMobileActions(msgId) {
    if (activeMsgId === msgId) return;
    hideMobileActions();

    activeMsgId = msgId;
    var $msg = $('#msg_' + msgId);
    $msg.addClass('mobile-actions-visible');

    // Initialize Lucide icons that may not have been processed while hidden
    if (window.LucideIcons) {
      window.LucideIcons.initialize($msg[0]);
    }
  }

  // Hide inline action buttons
  function hideMobileActions() {
    if (!activeMsgId) return;
    $('#msg_' + activeMsgId).removeClass('mobile-actions-visible');
    activeMsgId = null;
  }

  // Mobile tap handler. A tap on a message bubble toggles that message's action
  // buttons; a tap anywhere else (the empty row gutter, the avatar/name header,
  // another message, or outside the list) dismisses an open toolbar. One handler
  // so the same click can't both reveal and dismiss.
  $(document).on('click', function(e) {
    if (!isMobile()) return;

    var $t = $(e.target);

    // Let the action controls handle their own taps (toolbar buttons, the
    // dropdown, the bottom sheet, the reaction popover, the reaction picker sheet).
    if ($t.closest('.msg-hover-action, .msg-actions-menu, #msg-actions-sheet, #pm-reaction-sheet, .pm-reaction-popover').length) {
      return;
    }

    var $msg = $t.closest('#threads_right .pm_msg');
    // A tap counts as "on the bubble" only when it lands inside the bubble
    // wrapper and not on a link/button (photos are links → lightbox path).
    var onBubble = $msg.length > 0 &&
      $t.closest('.pm-msg-bubble-wrap').length > 0 &&
      $t.closest('a, button').length === 0 &&
      !$msg.hasClass('optimistic-msg');

    if (onBubble) {
      var msgId = getMsgId($msg[0]);
      if (!msgId) return;
      if (activeMsgId === msgId) {
        hideMobileActions();
      } else {
        showMobileActions(msgId);
      }
      return;
    }

    // Tap off the bubble → dismiss any open actions.
    if (activeMsgId) {
      hideMobileActions();
    }
  });

  // After a long-press reveals the toolbar, the browser still fires a click on
  // release. Swallow that one click (capture phase, before the delegated
  // lightbox/tap handlers) so the photo's lightbox does not also open. Scoped to
  // the long-pressed photo: a click on any other element is left untouched.
  // `stopPropagation` (not Immediate) keeps sibling capture handlers like the
  // reaction popover's outside-click dismissal working.
  document.addEventListener('click', function(e) {
    if (suppressClickEl && suppressClickEl.contains(e.target)) {
      e.preventDefault();
      e.stopPropagation();
      disarmSuppressClick();
    }
  }, true);

  // Suppress the native long-press context menu on photos (Android) so our
  // long-press gesture stays clean. iOS is handled by -webkit-touch-callout on
  // the photo link and image.
  $(document).on('contextmenu', '#threads_right a[data-lightbox]', function(e) {
    if (isMobile()) e.preventDefault();
  });

  // Open the bottom sheet (for "more" actions on mobile)
  window.openMessageActionsSheet = function(msgId) {
    var data = getMsgData(msgId);
    if (!data) return;

    activeSheetMsgId = msgId;
    $('#msg_' + msgId).find('.msg-actions-toggle').attr('aria-expanded', 'true');

    var previewText = data.senderName ? data.senderName + ': ' + data.preview : data.preview;
    $('#msg-actions-sheet-preview').text(previewText);

    var $report = $('#msg-actions-sheet-report');
    if (data.isOwnMessage) {
      $report.addClass('hidden');
    } else {
      $report.removeClass('hidden');
    }

    // Correct is offered only on the other user's text-bearing messages
    // (data-msg-raw carries the raw text the correction editor needs).
    var $correct = $('#msg-actions-sheet-correct');
    var hasRawText = !!$('#msg_' + msgId).attr('data-msg-raw');
    if (data.isOwnMessage || !hasRawText) {
      $correct.addClass('hidden');
    } else {
      $correct.removeClass('hidden');
    }

    // Premium "Edit" shows only on the viewer's own editable messages: the
    // server renders data-edit-source on exactly those rows (own + editable
    // type + inside the edit window). Mirrors the desktop dropdown gating.
    var $edit = $('#msg-actions-sheet-edit');
    if (data.canEdit) {
      $edit.removeClass('hidden');
    } else {
      $edit.addClass('hidden');
    }

    // Cancel any pending close animation
    if (sheetCloseTimer) {
      clearTimeout(sheetCloseTimer);
      sheetCloseTimer = null;
    }

    var $sheet = $('#msg-actions-sheet');
    var $panel = $('#msg-actions-sheet-panel');
    $sheet.removeClass('hidden');

    if (window.scrollLock) window.scrollLock.lock();
    if (navigator.vibrate) navigator.vibrate(10);

    requestAnimationFrame(function() {
      $panel[0].style.transform = 'translateY(0)';
    });
  };

  // Close the bottom sheet
  window.closeMessageActionsSheet = function() {
    $(".msg-actions-toggle[aria-expanded='true']").attr("aria-expanded", "false");

    var $sheet = $('#msg-actions-sheet');
    var $panel = $('#msg-actions-sheet-panel');

    $panel[0].style.transform = 'translateY(100%)';

    sheetCloseTimer = setTimeout(function() {
      sheetCloseTimer = null;
      $sheet.addClass('hidden');
      activeSheetMsgId = null;
      if (window.scrollLock) window.scrollLock.unlock();
    }, 200);
  };

  // Wire up sheet action buttons
  $(document).on('click', '#msg-actions-sheet-backdrop', function() {
    window.closeMessageActionsSheet();
  });

  $(document).on('click', '#msg-actions-sheet-reply', function() {
    if (activeSheetMsgId) window.replyToMessage(activeSheetMsgId);
    window.closeMessageActionsSheet();
  });

  $(document).on('click', '#msg-actions-sheet-correct', function() {
    var msgId = activeSheetMsgId;
    window.closeMessageActionsSheet();
    if (msgId) window.correctMessage(msgId);
  });

  $(document).on('click', '#msg-actions-sheet-edit', function() {
    var msgId = activeSheetMsgId;
    window.closeMessageActionsSheet();
    if (msgId && window.edit_message) window.edit_message(msgId);
  });

  $(document).on('click', '#msg-actions-sheet-report', function() {
    if (activeSheetMsgId) window.report_message(activeSheetMsgId);
    window.closeMessageActionsSheet();
  });

  $(document).on('click', '#msg-actions-sheet-delete', function() {
    var msgId = activeSheetMsgId;
    window.closeMessageActionsSheet();
    if (msgId) window.delete_message(msgId);
  });

  $(document).on('keydown', function(e) {
    if (e.key === 'Escape' && activeSheetMsgId) {
      window.closeMessageActionsSheet();
    }
  });

  // -------------------------------------------------------------------------
  // Mobile swipe-to-reply
  // -------------------------------------------------------------------------
  var SWIPE_THRESHOLD = 60;
  var swipeStartX = 0;
  var swipeStartY = 0;
  var swipeMsgEl = null;
  var swiping = false;
  var swipeTriggered = false;

  // Reusable reply hint icon shown to the left of the swiped message
  var $swipeHint = $('<div class="swipe-reply-hint"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 17 4 12 9 7"></polyline><path d="M20 18v-2a4 4 0 0 0-4-4H4"></path></svg></div>');

  function showSwipeHint(msgEl, progress) {
    var $msg = $(msgEl);
    var container = $msg.parent()[0];
    if (!$swipeHint[0].parentNode && container) {
      // Append to the scroll container so it stays fixed while the message translates
      $(container).append($swipeHint);
    }
    // Position vertically centered on the message body
    var msgBody = $msg.find('.msg_body')[0];
    if (msgBody && container) {
      var bodyRect = msgBody.getBoundingClientRect();
      var containerRect = container.getBoundingClientRect();
      $swipeHint[0].style.top = (bodyRect.top - containerRect.top + container.scrollTop + bodyRect.height / 2) + 'px';
    }
    var scale = Math.min(progress, 1);
    $swipeHint[0].style.opacity = scale;
    $swipeHint[0].style.transform = 'translateY(-50%) scale(' + (0.5 + 0.5 * scale) + ')';
  }

  function hideSwipeHint() {
    $swipeHint.detach();
  }

  $(document).on('touchstart', '#threads_right .pm_msg', function(e) {
    if (!isMobile()) return;
    if ($(e.currentTarget).hasClass('optimistic-msg')) return;
    var touch = e.originalEvent.touches[0];
    swipeStartX = touch.clientX;
    swipeStartY = touch.clientY;
    swipeMsgEl = e.currentTarget;
    swiping = false;
    swipeTriggered = false;

    // Arm long-press on a photo to reveal its actions toolbar. A short tap still
    // opens the lightbox; holding without moving reveals react/reply/more.
    clearLongPress();
    var photoEl = $(e.target).closest('a[data-lightbox]')[0];
    if (photoEl) {
      var rowEl = e.currentTarget;
      longPressTimer = setTimeout(function() {
        longPressTimer = null;
        // Swallow the release click on this exact photo so the lightbox doesn't
        // also open. Auto-disarm after the window in case no click is emitted.
        disarmSuppressClick();
        suppressClickEl = photoEl;
        suppressClickTimer = setTimeout(disarmSuppressClick, SUPPRESS_CLICK_MS);
        // The long-press consumed the gesture: drop swipe-to-reply tracking so a
        // later drag can't also fire a reply.
        swipeMsgEl = null;
        if (navigator.vibrate) navigator.vibrate(10);
        var msgId = getMsgId(rowEl);
        if (msgId) showMobileActions(msgId);
      }, LONG_PRESS_MS);
    }
  });

  $(document).on('touchmove', '#threads_right .pm_msg', function(e) {
    // Any real movement (scroll or swipe) cancels a pending long-press.
    if (longPressTimer) {
      var lt = e.originalEvent.touches[0];
      if (Math.abs(lt.clientX - swipeStartX) > 10 || Math.abs(lt.clientY - swipeStartY) > 10) {
        clearLongPress();
      }
    }
    if (!swipeMsgEl || swipeTriggered) return;
    var touch = e.originalEvent.touches[0];
    var dx = touch.clientX - swipeStartX;
    var dy = Math.abs(touch.clientY - swipeStartY);

    // Only track horizontal right swipe; ignore if vertical movement dominates
    if (dy > 30 && !swiping) {
      swipeMsgEl = null;
      return;
    }

    if (dx > 10) {
      swiping = true;
      var offset = Math.min(dx, 80);
      swipeMsgEl.style.transform = 'translateX(' + offset + 'px)';
      swipeMsgEl.style.transition = 'none';

      // Animate reply hint icon based on progress toward threshold
      showSwipeHint(swipeMsgEl, dx / SWIPE_THRESHOLD);

      if (dx >= SWIPE_THRESHOLD && !swipeTriggered) {
        swipeTriggered = true;
        if (navigator.vibrate) navigator.vibrate(10);
      }
    }
  });

  $(document).on('touchend touchcancel', '#threads_right .pm_msg', function() {
    clearLongPress();
    if (!swipeMsgEl) return;
    var el = swipeMsgEl;

    // Animate back
    el.style.transition = 'transform 0.2s ease-out';
    el.style.transform = '';
    hideSwipeHint();

    if (swipeTriggered) {
      var msgId = getMsgId(el);
      if (msgId) {
        window.replyToMessage(msgId);
      }
    }

    // Clean up after animation
    setTimeout(function() {
      el.style.transition = '';
    }, 200);

    swipeMsgEl = null;
    swiping = false;
    swipeTriggered = false;
  });
})();
